import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * Body of R6. `durationMs` is the recorded time, pauses excluded (measured by the capture clock for a
 * recording, probed from the file for an import), and `null` is always a valid value here
 * (`OutboxPort.ts`: losing the recording would be far worse than a missing duration).
 */
class CompleteRecording {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly recordingId: number,
		public readonly durationMs: number | null,
		public readonly segmentCount: number,
		public readonly mimeType: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			durationMs: this.durationMs,
			segmentCount: this.segmentCount,
			mimeType: this.mimeType,
		};
	}
}

export default CompleteRecording;
